import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose'
import Appointment from './Appointment'

const withPrintable = withStateHandlers({
  printable: false
}, {
  setPrintable: () => ({ printable }) => ({ printable })
})

const withPrintHandler = withHandlers({
  printHandler: ({ setPrintable }) => e => {
    setPrintable({ printable: true })
  }
})

const withWaitUntilRenderToPrint = lifecycle({
  componentDidUpdate({ printable: prevPrintable }) {
    const {
      printable,
      setPrintable
    } = this.props

    if (printable && printable !== prevPrintable) {
      window.print()
      setPrintable({ printable: false })
    }
  }
})

export default compose(
  withPrintable,
  withPrintHandler,
  withWaitUntilRenderToPrint
)(Appointment)
